import { createFileRoute } from '@tanstack/react-router'
import { AdminContractors } from '../features/admin/contractors'
import { adminRouteState } from '../features/admin/route-state'

export const Route = createFileRoute('/admin/contractors')({
  ...adminRouteState,
  component: AdminContractors,
})
